import {
  Button,
  FormControlLabel,
  FormGroup,
  Stack,
  styled,
  Switch,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { RoleContext } from "../lib/contexts/RoleContext";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#1890ff",
        ...(theme.palette.mode === "dark" && {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...(theme.palette.mode === "dark" && {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

const RouteSwitchButton = () => {
  const { role, setRole } = useContext(RoleContext);

  // const location = useLocation();
  // const navigate = useNavigate();

  const handleRoleSwitch = (e: any) => {
    e.preventDefault();
    const switchedRole = role === "learn" ? "prism" : "learn";

    window.location.href = `${window.location.origin}/${switchedRole}`;
  };

  return (
    <FormGroup>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Typography>Learn</Typography>
        <AntSwitch
          checked={role === "prism"}
          onChange={handleRoleSwitch}
          inputProps={{ "aria-label": "role switch" }}
        />
        <Typography>Prism</Typography>
      </Stack>
    </FormGroup>
  );
};

export default RouteSwitchButton;
